
// // 1. this code set by nk

// import React, { createContext, useEffect, useState } from "react";
// import AxiosApi from "../api/AxiosApi";
// import { useNavigate } from "react-router-dom";

// export const BusinessAuthenticationContext = createContext();

// export function BusinessAuthenticationProvider({ children }) {
//     const Navigate = useNavigate();

//     // ✅ LocalStorage se Initial State Set Karna
//     const [IsLoggedIn, setIsLoggedIn] = useState(false);

//     const [LoginLoadingIn, setLoginLoadingIn] = useState(false);
//     const [LoggedInUserInfoIn, setLoggedInUserInfoIn] = useState(false);

//     function userLoginBusiness(LOGIN_ID, PASSWORD, USER_NAME, USER_TYPE) {
//         localStorage.setItem('LOGIN_ID', LOGIN_ID)
//         // localStorage.setItem('PW', PW)
//         setLoginLoadingIn(true);

//         let headersList = {
//             Accept: '/',
//             'Content-Type': 'application/x-www-form-urlencoded',
//         };

//         let bodyContent = `LOGIN_ID=${LOGIN_ID}&PASSWORD=${PASSWORD}&USER_NAME=${USER_NAME}&USER_TYPE=${USER_TYPE}`;

//         AxiosApi.post('CMN_07_Super/SLogin', bodyContent, headersList)
//             .then((res) => {
//                 localStorage.setItem('SS_KEY', res?.data?.SS_KEY);
//                 localStorage.setItem('LoggedInUserInfoIn', JSON.stringify(res?.data));
//                 localStorage.setItem('isLoggedIn', "true");

//                 setLoggedInUserInfoIn(res?.data);
//                 setIsLoggedIn(true);
//                 setLoginLoadingIn(false);

//                 Navigate('/businessDashboard');
//             })
//             .catch(() => {
//                 alert('Invalid Credentials!');
//                 setLoginLoadingIn(false);
//             });
//     }


//     function logOutIn() {
//          localStorage.clear()
//         setLoggedInUserInfoIn(null)
//         setIsLoggedIn(false)
//         Navigate('/login')
//     }


//     //  useEffect(() => {
//     //         const data = localStorage.getItem('LoggedInUserInfoIn')
//     //         const userData = JSON.parse(data)
//     //         if (userData) {
//     //             setIsLoggedIn(true)
//     //             setLoggedInUserInfoIn(userData)
//     //           //  Navigate('/userDashboard')
//     //         } else {
//     //          //   setIsLogged(false)
//     //             setLoggedInUserInfoIn(null)
//     //           //  localStorage.clear()
//     //            // Navigate('login')
//     //         }
//     //     }, [IsLoggedIn])


//     useEffect(() => {
//         const data = localStorage.getItem('LoggedInUserInfoIn');
//         const userData = data ? JSON.parse(data) : null;

//         if (userData) {
//             const loginInfoData = localStorage.getItem("pass");

//             if (loginInfoData === "target") {  // ✅ Use `===` for comparison
//                 setIsLoggedIn(true);
//                 setLoggedInUserInfoIn(userData);
//             } else {
//                 setIsLoggedIn(false);
//                 setLoggedInUserInfoIn(null);


//             }
//         } else {
//             setIsLoggedIn(false);
//             setLoggedInUserInfoIn(null);
//         }
//     }, []); // ✅ Remove `[IsLoggedIn]` to prevent infinite re-renders



//     return (
//         <BusinessAuthenticationContext.Provider value={{ IsLoggedIn, userLoginBusiness, logOutIn, LoginLoadingIn, LoggedInUserInfoIn }}>
//             {children}
//         </BusinessAuthenticationContext.Provider>
//     );
// }

// 2.right code

// import React, { createContext, useEffect, useState } from "react";
// import AxiosApi from "../api/AxiosApi";
// import { useNavigate } from "react-router-dom";

// export const BusinessAuthenticationContext = createContext();

// export function BusinessAuthenticationProvider({ children }) {
//     const Navigate = useNavigate();
    
//     // ✅ LocalStorage se Initial State Set Karna
//     const [IsLoggedIn, setIsLoggedIn] = useState(false);

//     const [LoginLoadingIn, setLoginLoadingIn] = useState(false);
//     const [LoggedInUserInfoIn, setLoggedInUserInfoIn] = useState(false);
//     const [businessAuthLoading, setBusinessAuthLoading] = useState(true);

//     function userLoginBusiness(LOGIN_ID, PASSWORD, USER_NAME, USER_TYPE) {
//         localStorage.setItem('LOGIN_ID',LOGIN_ID)
//          localStorage.setItem('PASSWORD', PASSWORD)
//         console.log("pass",PASSWORD)
//         setLoginLoadingIn(true);

//         let headersList = {
//             Accept: '/',
//             'Content-Type': 'application/x-www-form-urlencoded',
//         };

//         let bodyContent = `LOGIN_ID=${LOGIN_ID}&PASSWORD=${PASSWORD}&USER_NAME=${USER_NAME}&USER_TYPE=${USER_TYPE}`;

//         AxiosApi.post('CMN_07_Super/SLogin', bodyContent, headersList)
//             .then((res) => {
//                 localStorage.setItem('SS_KEY', res?.data?.SS_KEY);
//                 localStorage.setItem('LoggedInUserInfoIn', JSON.stringify(res?.data));
//                localStorage.setItem('isLoggedIn', IsLoggedIn);

//                 setLoggedInUserInfoIn(res?.data);
//                 setIsLoggedIn(true);
//                 setLoginLoadingIn(false);

//                 Navigate('/businessDashboard');
//             })
//             .catch(() => {
//                 alert('Invalid Credentials!');
//                 setLoginLoadingIn(false);
//             });
//     }

    
//     function logOutIn() {
//         localStorage.clear()
//         setLoggedInUserInfoIn(null)
//         setIsLoggedIn(false)

//         // setTimeout(() => {
//         //     Navigate('/login', { replace: true });  // ✅ Ensure proper navigation
//         // }, 0);

//         Navigate('/login')
//     }

//     useEffect(() => {
//         const data = localStorage.getItem('LoggedInUserInfoIn');
//         const userData = data ? JSON.parse(data) : null;
    
//         if (userData && localStorage.getItem("pass") === "target") {
//             setIsLoggedIn(true);
//             setLoggedInUserInfoIn(userData);
//         } else {
//             setIsLoggedIn(false);
//             setLoggedInUserInfoIn(null);
//         }
    
//         setBusinessAuthLoading(false);  // ✅ Done loading
//     }, []);


//     return (
//         <BusinessAuthenticationContext.Provider value={{ IsLoggedIn, userLoginBusiness, logOutIn, LoginLoadingIn, LoggedInUserInfoIn,businessAuthLoading }}>
//             {children}
//         </BusinessAuthenticationContext.Provider>
//     );
// }

// 3.

// import React, { createContext, useEffect, useState } from "react";
// import AxiosApi from "../api/AxiosApi";
// import { useNavigate } from "react-router-dom";

// export const BusinessAuthenticationContext = createContext();

// export function BusinessAuthenticationProvider({ children }) {
//     const Navigate = useNavigate();
    
//     const [IsLoggedIn, setIsLoggedIn] = useState(false);
//     const [LoginLoadingIn, setLoginLoadingIn] = useState(false);
//     const [LoggedInUserInfoIn, setLoggedInUserInfoIn] = useState(false);
//     const [businessAuthLoading, setBusinessAuthLoading] = useState(true);

//     function userLoginBusiness(LOGIN_ID, PASSWORD, USER_NAME, USER_TYPE) {
//         // ✅ Unique keys for Superuser
//         localStorage.setItem('SU_LOGIN_ID', LOGIN_ID);
//         localStorage.setItem('SU_PASSWORD', PASSWORD);
        
//         setLoginLoadingIn(true);

//         let headersList = {
//             Accept: '/',
//             'Content-Type': 'application/x-www-form-urlencoded',
//         };

//         let bodyContent = `LOGIN_ID=${LOGIN_ID}&PASSWORD=${PASSWORD}&USER_NAME=${USER_NAME}&USER_TYPE=${USER_TYPE}`;

//         AxiosApi.post('CMN_07_Super/SLogin', bodyContent, headersList)
//             .then((res) => {
//                 // ✅ Unique keys for Superuser Response
//                 localStorage.setItem('SU_SS_KEY', res?.data?.SS_KEY);
//                 localStorage.setItem('SU_LoggedInUserInfoIn', JSON.stringify(res?.data));
//                 localStorage.setItem('SU_isLoggedIn', 'true');

//                 setLoggedInUserInfoIn(res?.data);
//                 setIsLoggedIn(true);
//                 setLoginLoadingIn(false);

//                 Navigate('/businessDashboard');
//             })
//             .catch(() => {
//                 alert('Invalid Credentials!');
//                 setLoginLoadingIn(false);
//             });
//     }

//     function logOutIn() {
//         // ❌ localStorage.clear() को हटाया
//         // ✅ सिर्फ सुपरयूजर का डेटा डिलीट करें
//         localStorage.removeItem('SU_LOGIN_ID');
//         localStorage.removeItem('SU_PASSWORD');
//         localStorage.removeItem('SU_SS_KEY');
//         localStorage.removeItem('SU_LoggedInUserInfoIn');
//         localStorage.removeItem('SU_isLoggedIn');

//         setLoggedInUserInfoIn(null);
//         setIsLoggedIn(false);
//         Navigate('/login');
//     }

//     useEffect(() => {
//         // ✅ Updated key here
//         const data = localStorage.getItem('SU_LoggedInUserInfoIn');
//         const userData = data ? JSON.parse(data) : null;
    
//         // ध्यान दें: पहले यहाँ "pass" === "target" चेक था, उसे अपनी जरूरत के हिसाब से रखें
//         if (userData) {
//             setIsLoggedIn(true);
//             setLoggedInUserInfoIn(userData);
//         } else {
//             setIsLoggedIn(false);
//             setLoggedInUserInfoIn(null);
//         }
    
//         setBusinessAuthLoading(false);
//     }, []);

//     return (
//         <BusinessAuthenticationContext.Provider value={{ IsLoggedIn, userLoginBusiness, logOutIn, LoginLoadingIn, LoggedInUserInfoIn, businessAuthLoading }}>
//             {children}
//         </BusinessAuthenticationContext.Provider>
//     );
// }

// 4. this is code for name changing

import React, { createContext, useEffect, useState } from "react";
import AxiosApi from "../api/AxiosApi";
import { useNavigate } from "react-router-dom";

// export const BusinessAuthenticationContext = createContext();

// export function BusinessAuthenticationProvider({ children }) {
//     const Navigate = useNavigate();
    
//     const [IsLoggedIn, setIsLoggedIn] = useState(false);
//     const [LoginLoadingIn, setLoginLoadingIn] = useState(false);
//     const [LoggedInUserInfoIn, setLoggedInUserInfoIn] = useState(false);
//     const [businessAuthLoading, setBusinessAuthLoading] = useState(true);

//     function userLoginBusiness(LOGIN_ID, PASSWORD, USER_NAME, USER_TYPE) {
//         // ✅ Business/Superuser के लिए अलग unique keys
//         localStorage.setItem('business_LOGIN_ID', LOGIN_ID);
//         localStorage.setItem('business_PASSWORD', PASSWORD);
        
//         setLoginLoadingIn(true);

//         let headersList = {
//             Accept: '/',
//             'Content-Type': 'application/x-www-form-urlencoded',
//         };

//         let bodyContent = `LOGIN_ID=${LOGIN_ID}&PASSWORD=${PASSWORD}&USER_NAME=${USER_NAME}&USER_TYPE=${USER_TYPE}`;

//         AxiosApi.post('CMN_07_Super/SLogin', bodyContent, headersList)
//             .then((res) => {
//                 localStorage.setItem('business_SS_KEY', res?.data?.SS_KEY);
//                 localStorage.setItem('business_LoggedInUserInfoIn', JSON.stringify(res?.data));
//                  localStorage.setItem('business_isLoggedIn', 'true');
//                 // localStorage.setItem('isLoggedIn', IsLoggedIn);

//                 setLoggedInUserInfoIn(res?.data);
//                 setIsLoggedIn(true);
//                 setLoginLoadingIn(false);

//                 Navigate('/businessDashboard');
//             })
//             .catch(() => {
//                 alert('Invalid Credentials!');
//                 setLoginLoadingIn(false);
//             });
//     }

//     function logOutIn() {
//         // ✅ सिर्फ बिजनेस/सुपरयूजर का डेटा डिलीट होगा
//         localStorage.removeItem('business_LOGIN_ID');
//         localStorage.removeItem('business_PASSWORD');
//         localStorage.removeItem('business_SS_KEY');
//         localStorage.removeItem('business_LoggedInUserInfoIn');
//         localStorage.removeItem('business_isLoggedIn');

//         setLoggedInUserInfoIn(null);
//         setIsLoggedIn(false);
//         Navigate('/login');
//     }

//     useEffect(() => {
//         const data = localStorage.getItem('business_LoggedInUserInfoIn');
//         const userData = data ? JSON.parse(data) : null;
    
//         if (userData) {
//             setIsLoggedIn(true);
//             setLoggedInUserInfoIn(userData);
//         } else {
//             setIsLoggedIn(false);
//             setLoggedInUserInfoIn(null);
//         }
    
//         setBusinessAuthLoading(false);
//     }, []);

//     return (
//         <BusinessAuthenticationContext.Provider value={{ IsLoggedIn, userLoginBusiness, logOutIn, LoginLoadingIn, LoggedInUserInfoIn, businessAuthLoading }}>
//             {children}
//         </BusinessAuthenticationContext.Provider>
//     );
// }





export const BusinessAuthenticationContext = createContext();

export function BusinessAuthenticationProvider({ children }) {
    const Navigate = useNavigate();
    
    const [IsLoggedIn, setIsLoggedIn] = useState(false);
    const [LoginLoadingIn, setLoginLoadingIn] = useState(false);
    const [LoggedInUserInfoIn, setLoggedInUserInfoIn] = useState(null); 
    const [businessAuthLoading, setBusinessAuthLoading] = useState(true);

    function userLoginBusiness(LOGIN_ID, PASSWORD, USER_NAME, USER_TYPE) {
        // Business/Superuser के लिए अलग unique keys
        localStorage.setItem('business_LOGIN_ID', LOGIN_ID);
        localStorage.setItem('business_PASSWORD', PASSWORD);
        
        setLoginLoadingIn(true);

        let headersList = {
            Accept: '/',
            'Content-Type': 'application/x-www-form-urlencoded',
        };

        let bodyParams = new URLSearchParams();
        bodyParams.append('LOGIN_ID', LOGIN_ID);
        bodyParams.append('PASSWORD', PASSWORD);
        bodyParams.append('USER_NAME', USER_NAME);
        bodyParams.append('USER_TYPE', USER_TYPE);

        AxiosApi.post('CMN_07_Super/SLogin', bodyParams, headersList)
            .then((res) => {
                localStorage.setItem('business_SS_KEY', res?.data?.SS_KEY);
                localStorage.setItem('business_LoggedInUserInfoIn', JSON.stringify(res?.data));
                localStorage.setItem('business_isLoggedIn', 'true');

                setLoggedInUserInfoIn(res?.data);
                setIsLoggedIn(true);
                setLoginLoadingIn(false);

                Navigate('/businessDashboard');
            })
            .catch((er) => {
                alert('Invalid Business Credentials!');
                setLoginLoadingIn(false);
            });
    }

    function logOutIn() {
        // सिर्फ बिजनेस/सुपरयूजर का डेटा डिलीट होगा, यूजर का नहीं
        localStorage.removeItem('business_LOGIN_ID');
        localStorage.removeItem('business_PASSWORD');
        localStorage.removeItem('business_SS_KEY');
        localStorage.removeItem('business_LoggedInUserInfoIn');
        localStorage.removeItem('business_isLoggedIn');

        setLoggedInUserInfoIn(null);
        setIsLoggedIn(false);
        Navigate('/login');
    }

    // ऐप रीलोड या नया टैब ओपन होने पर बिजनेस ऑथ स्टेट को लोकल स्टोरेज से सिंक करना
    useEffect(() => {
        const data = localStorage.getItem('business_LoggedInUserInfoIn');
        const userData = data ? JSON.parse(data) : null;
    
        if (userData) {
            setIsLoggedIn(true);
            setLoggedInUserInfoIn(userData);
        } else {
            setIsLoggedIn(false);
            setLoggedInUserInfoIn(null);
        }
    
        setBusinessAuthLoading(false);
    }, []);

    return (
        <BusinessAuthenticationContext.Provider 
            value={{ 
                IsLoggedIn, 
                userLoginBusiness, 
                logOutIn, 
                LoginLoadingIn, 
                LoggedInUserInfoIn, 
                businessAuthLoading 
            }}
        >
            {children}
        </BusinessAuthenticationContext.Provider>
    );
}